import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Roboto:100,300,300i,400,400i,500,500i,700,900');

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  *, *::after, *::before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  html,
  .app-wrapper {
    overflow-x: hidden;
    position:relative;
  }

  body {
    background: #fff;
    color: #4A5568;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    overflow-x: hidden;
    position:relative;

    &.sticky-header {
      padding-top: 119.59px;
      @media(min-width: 50rem) {
        padding-top: 136px;
      }
    }
  }

  .app-wrapper {
    overflow-x: hidden;
  }

  h1, .h1 {
    font-size: 4rem;
    font-weight: 600;
    color: #2D3748;
  }

  h2, .h2 {
    font-size: 2rem;
  }

  h3, .h3 {
    font-size: 1.5rem;
  }

  h4, .h4 {
    font-size: 1rem;
    font-weight: 500;
  }

  h5, .h5 {
    font-size: .8rem;
  }

  h6, .h6 {
    font-size: .5rem;
  }

  p {
    margin: 0;
    font-size: 1rem;
    font-weight: 400;
  }

  a {
    color: #0070E0;
    text-decoration: none;
    &:hover {
      color: #0059b3;
    }
  }

  img,
  video {
    max-width: 100%;
    height: auto;
  }

  ul, ol {
    list-style: none;
  }

  .Modal {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0, .4);
  }

  .Backdrop {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0, .4);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .css-rsvirr, [data-css-rsvirr] {
    transform: translateY(0px) !important;
  }
`;
